import { useEffect } from "react";
import { useParams } from "@reach/router";
import { navigateActivation } from "../utils/url";
import useUnlockAllowed from "./useUnlockAllowed";

export default function useRequireUnlockAllowed(): boolean {
  const params = useParams();
  const { isUnlockAllowed, isLoadingUnlockAllowed } = useUnlockAllowed(
    params?.podKeyOrSerialNumber
  );

  useEffect(() => {
    if (!isUnlockAllowed && !isLoadingUnlockAllowed) {
      navigateActivation(
        params?.podKeyOrSerialNumber ? `${params.podKeyOrSerialNumber}/` : "/"
      );
    }
  }, [isUnlockAllowed, isLoadingUnlockAllowed]);

  return isUnlockAllowed;
}
